import { api } from '@/services'
import { setCompletedLessonsCount } from '@/common/utils'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const useCoursesStore = defineStore('courses', () => {
  const list = ref([])
  const loading = ref(true)

  function setCourses(courses) {
    const coursesMap = courses.map((course) => {
      return {
        ...course,
        // set number of completed lessons based on corresponding enrollment
        lessons_completed: setCompletedLessonsCount(course)
      }
    })
    list.value = coursesMap
  }
  async function fetchCourses({ params }) {
    loading.value = true
    try {
      const response = await api.get(
        `/api/companies/${params.companyId}/courses`,
        {
          params: {
            subjects: params.subjects,
            language: params.language
          }
        }
      )
      setCourses(response.data.data)
    } finally {
      loading.value = false
    }
  }

  return { list, loading, setCourses, fetchCourses }
})
export default useCoursesStore
